<template>
  <div class="information">
    <div class="main_box">
      <p class="title">基本资料</p>
      <div class="top_form">
        <el-form :inline="true" :model="formInline" label-width="90px" class="demo-form-inline">
          <el-form-item label="学校：">
            <el-input v-model="formInline.school" disabled placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item label="用户名：">
            <el-input v-model="formInline.userName" disabled placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item label="年级：">
            <el-input v-model="formInline.grade" disabled placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item label="班级：">
            <el-input v-model="formInline.class" disabled placeholder="审批人"></el-input>
          </el-form-item>
          <el-form-item label="性 别：">
            <el-radio-group v-model="radio" disabled>
              <!-- 未选中的样式  defaultradio  -->
              <el-radio :class="radio != 1 ? 'defaultradio' : ''"  :label="2">女</el-radio>
              <el-radio :class="radio != 2 ? 'defaultradio' : ''"  :label="1">男</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="Personalization">
        <p class="title">个性化设置</p>
        <div class="btm_form">
          <el-form :inline="true" label-width="110px" class="demo-form-inline">
            <el-form-item label="护眼模式：">
              <el-switch @change="eyeChange(formInline.eye)" v-model="formInline.eye" active-color="#5990FF" inactive-color="#CCCCCC" :active-text="showName(formInline.eye,1)">
              </el-switch>
            </el-form-item>
            <el-form-item label="发音模式：">
              <el-switch @change="fyChange(formInline.sound)" v-model="formInline.sound" active-color="#5990FF" inactive-color="#F93A00" :active-text="showName(formInline.sound,2)">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selectClassByYhid, myPersonalConfig, addPersonalConfig, updatePersonalConfig } from "@/api/student";
export default {
  data() {
    return {
      formInline: {
        school: "阿萨",
        grade: "",
        userName: "",
        class: "",
        eye: false,
        sound: "",
      },
      radio: 1,
      isSetUp: false, // 是否设置过
      uid: ''
    };
  },
  methods: {
    // 查询个性化设置
    myPersonalConfigFun() {
      myPersonalConfig({xsid: this.$store.state.userInfo.yhid}).then(res => {
        if(!res.result) {
          this.isSetUp = true
          return
        }
        localStorage.setItem(`sound_${this.$store.state.userInfo.realname}`, res.result.fyms ? 'mg' : 'yg' )
        this.uid = res.result.id
        this.formInline.eye = res.result.hyms
        this.formInline.sound = res.result.fyms
      })
    },
    // 新增个性化设置
    addPersonalConfigFun(){
      addPersonalConfig({
        cjr: this.$store.state.userInfo.yhid,
        xgr: this.$store.state.userInfo.yhid,
        xsid: this.$store.state.userInfo.yhid,
        fyms: this.formInline.sound - 0,
        hyms: this.formInline.eye - 0
      }).then(res => {
        this.myPersonalConfigFun()
      }).catch(() => {
        this.$message.warning('基本资料修改失败，请刷新网页或联系管理员')
      })
    },
    // 修改个性化设置
    updatePersonalConfigFun(){
      updatePersonalConfig({
        fyms: this.formInline.sound - 0,
        hyms: this.formInline.eye - 0,
        xsid: this.$store.state.userInfo.yhid,
        id: this.uid
      }).then(res => {
        this.myPersonalConfigFun()
      }).catch(() => {
        this.$message.warning('基本资料修改失败，请刷新网页或联系管理员')
      })
    },
    eyeChange(val) {
      if(this.isSetUp){
        this.addPersonalConfigFun()
      }
      this.updatePersonalConfigFun()
      sessionStorage.setItem('eye', val)
      this.$Bus.$emit("eye", val);
    },
    fyChange(val) {
      if(this.isSetUp){
        this.addPersonalConfigFun()
      }
      this.updatePersonalConfigFun()
      this.$message.success(!val ? '英式发音切换成功' : '美式发音切换成功')
    },
    // switch显示文字
    showName(val, type) {
      if (type == 1) {
        return val ? "开启" : "关闭";
      } else {
        return val ? "美式" : "英式";
      }
    },
  },
  mounted() {
    this.myPersonalConfigFun()
    selectClassByYhid({ yhid: this.$store.state.userInfo.yhid }).then((res) => {
      this.$set(this.formInline, "grade", res.result[0].njmc);
      this.$set(this.formInline, "class", res.result[0].bjmc);
    });

    this.$set( this.formInline, "school", JSON.parse(sessionStorage.getItem("userInfo")).zhmc);
    this.$set(this.formInline, "userName",JSON.parse(sessionStorage.getItem("userInfo")).realname);

    // 性别
    this.radio = JSON.parse(sessionStorage.getItem("userInfo")).xb - 0;
    console.log(this.radio)
  },
};
</script>
<style lang="scss" scoped>
.information {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;
  .main_box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 3.5% 2% 2%;
    box-sizing: border-box;
    position: relative;
    .title {
      font-size: 1.3vw;
      font-weight: bold;
      height: 2vw;
      line-height: 2vw;
    }
    .top_form {
      margin-top: 2vw;
      border-bottom: 2px solid #ededed;
    }
    .Personalization {
      width: 100%;
      height: calc(100% - 16vw);
      // border: 1px solid red;
      box-sizing: border-box;
      padding-top: 2.5%;
      .btm_form {
        margin-top: 2vw;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .information {
    width: calc(100% - 80px);
    padding: 0 10px;
    height: 100%;
    overflow: auto;

    .main_box {
      padding: 20px 15px;
      height: auto;
      min-height: 100%;

      .title {
        font-size: 16px;
        height: auto;
        line-height: 1.4;
        margin-bottom: 15px;
      }

      .top_form {
        margin-top: 0;
        border-bottom: 1px solid #ededed;
        padding-bottom: 15px;
      }

      .Personalization {
        height: auto;
        padding-top: 15px;

        .btm_form {
          margin-top: 10px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .information {
    width: calc(100% - 65px);
    padding: 0 8px;

    .main_box {
      padding: 20px 16px;
    }
  }
}
</style>
<style lang="scss">
.information {
  .el-form--inline .el-form-item {
    width: 40%;
    margin-bottom: 2vw;
    height: 2vw;
  }
  .el-form-item__label {
    font-size: 1vw;
  }
  .el-form--inline .el-form-item__content {
    width: 75%;
    height: 2vw;
  }
  .el-input.is-disabled .el-input__inner {
    box-sizing: border-box;
    padding-left: 2vw;
    color: #333;
    height: 2.55vw;
    font-size: 1vw;
    line-height: 2.55vw;
  }
  .defaultradio {
    .el-radio__inner {
      border: 1px solid #ff7a3f;
    }
    .el-radio__inner::after {
      width: 4px;
      height: 4px;
      border-radius: 100%;
      background-color: #ff7a3f;
      content: "";
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale(1);
      transition: transform 0.15s ease-in;
    }
  }
  .btm_form {
    .el-form--inline .el-form-item {
      width: 75%;
    }
  }
  .el-switch {
    position: relative;
    height: 24px;
    line-height: 24px;
    &.is-checked {
      .el-switch__core {
        // border-color: #41BDA2;
        // background-color: #41BDA2;
        &:after {
          margin-left: -22px;
        }
      }
    }
    .el-switch__label,
    .el-switch__core {
      width: 59px !important;
      height: 24px;
      // border-color: #ececec;
      // background-color: #ececec;
    }
    .el-switch__core {
      border-radius: 12px;
      border: none;
      background: #f1f1f1;
      &:after {
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.3);
        width: 22px;
        height: 22px;
      }
    }
    .el-switch__label.is-active {
      color: #333;
    }
    .el-switch__label--right {
      margin-left: 0px;
      &.is-active {
        color: #fff;
        right: 24px;
      }
      position: absolute;
      right: 5px;
      top: -1px;
      color: #fff;
      text-align: right;
      > span {
        font-size: 12px;
        font-weight: normal;
      }
    }
  }
  .el-switch.is-checked {
    .el-switch__core {
      width: 59px;
      border-color: #ececec;
      background-color: #ececec;
    }
  }
  .el-switch.is-disabled {
    opacity: 1;
  }
  .el-switch.is-disabled .el-switch__core,
  .el-switch.is-disabled .el-switch__label {
    cursor: pointer !important;
  }
  .el-switch__core:after {
    border-radius: 50%;
    width: 10px !important;
    height: 10px !important;
    background: #5990ff;
    border: 6px solid #fff;
  }
  .el-radio__label {
    font-size: 1vw;
  }
}
@media screen and (max-width: 768px) {
  .information {
    .el-form--inline .el-form-item {
      width: 100% !important;
      margin-bottom: 16px;
      height: auto;
      display: flex;
      flex-wrap: wrap;
    }

    .el-form-item__label {
      font-size: 14px;
      width: 90px !important;
      line-height: 40px;
      text-align: right;
      padding-right: 12px;
    }

    .el-form--inline .el-form-item__content {
      width: calc(100% - 90px) !important;
      height: auto;
      line-height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .el-input.is-disabled .el-input__inner {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      padding-left: 12px;
    }

    .el-radio-group {
      display: flex;
      gap: 20px;
    }

    .el-radio {
      margin-right: 0;
    }

    .el-radio__label {
      font-size: 14px;
    }

    .btm_form .el-form--inline .el-form-item {
      width: 100% !important;
      display: flex;
      flex-wrap: wrap;
    }

    .el-switch {
      .el-switch__label--right {
        span {
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .information {
    .el-form-item__label {
      font-size: 12px;
      width: 80px !important;
      line-height: 36px;
    }

    .el-form--inline .el-form-item__content {
      width: calc(100% - 80px) !important;
      line-height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .el-input.is-disabled .el-input__inner {
      height: 36px;
      line-height: 36px;
      font-size: 12px;
    }

    .el-radio__label {
      font-size: 12px;
    }

    .el-switch {
      .el-switch__label--right {
        span {
          font-size: 11px;
        }
      }
    }
  }
}
</style>
